







































import {
  defineComponent,
  ref,
  useContext,
  useAsync,
  onMounted
} from '@nuxtjs/composition-api';

import HeadlessFlipCard from "~/components/Headless/FlipCard.vue";
import SvgImage from '~/components/General/SvgImage.vue';
import HeadlessGallery from '~/components/Headless/Gallery.vue';
import CategoryWatermark from '~/components/Headless/Watermarks/CategoryWatermark.vue';
import CircleGradient from '~/components/Headless/Watermarks/CircleGradient.vue';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { useCache, CacheTagPrefix } from '@vue-storefront/cache';

export default defineComponent({
  name: "Wedding",
  components: {
    HeadlessFlipCard, SvgImage, CategoryWatermark, CircleGradient, HeadlessGallery
  },
  setup() {
    const { app, $strapi } = useContext();
    const events = ref(null);
    const results = ref(null);
    const isShow = ref(false);
    const isVenue = ref(false);
    const WeddingFlowerGallery = ref([]);
    const weddingRef =  ref<HTMLElement | null>(null);
    const viewWeddingFlowerGallery = ref(false);
    const galleryButtonText = ref('View All');
    const { addTags } = useCache();
    const page = {
      title: "Chichester Wedding Florist",
      meta_description: "At Hedge Rose Chichester, we take great pride in selecting only the freshest and best quality of flowers for your special day",
      og_image: '',
    };
    const qs = require('qs');
    const query = qs.stringify({
      populate: [
        'image.media',
        'gallery.media'
      ],
    }, {
      encodeValuesOnly: true, // prettify URL
    });

    // Interfaces
    interface wedding {
      data: [
        weddingData
      ]
    }

    interface weddingData {
      id: string,
      attributes: weddingAttributes,
    }

    interface weddingAttributes {
      title: String;
      description: String;
      name: String;
      date: String;
      seasons: String;
      venue: String;
      slug: String;
      shortdescription: String;
      descriptionSecondColumn: String;
      photographerUrl: String;
      photographer: String;
      image: weddingImage;
    }

    interface weddingImage {
      data: {
        id: string;
        attributes: imageAttributes;
      }
    }

    interface imageAttributes {
      name: String;
      alternativeText: String;
      caption: String;
      width: String;
      height: String;
      url: String;
    }

    // Get Strapi data
    const setOGimage = (value) => {
      if (value[0].image.data.attributes.url)
        page.og_image = value[0].image.data.attributes.url;
    }

    useAsync(async () => {
      const response: wedding = await $strapi.find('weddings?' + query);
      events.value = response.data.map((event) => {
        return event.attributes;
      });
      results.value = events.value;

      // Loop to get all gallery images with the caption of "flower"
      let galleryArray = [];
      results.value.forEach(function(item: any) {
        if (item.gallery.data) {
          let galleryItem = item.gallery.data;
          galleryItem.forEach(function(item: any) {
            galleryArray.push(item.attributes);
          })
        }
      })
      galleryArray.forEach(function(item: any) {
        // if (item.caption == 'flower') {
          WeddingFlowerGallery.value.push(item);
        // }
      })

      setOGimage(results.value);
    });

    // Toggles the Headless Gallery and changes the button text
    const toggleGallery = () => {
      viewWeddingFlowerGallery.value = !viewWeddingFlowerGallery.value;
      if (viewWeddingFlowerGallery.value == true) {
        galleryButtonText.value = "View Weddings";
      } else {
        galleryButtonText.value = "View All";
      }
    }

    const countSeasons = (array: any) => {
      let result = {};
      if (!array) return;
      array.forEach(function(item: any) {
        if (item.seasons != null)
          result[item.seasons] = (result[item.seasons] || 0) + 1;
      });
      return result;
    };

    const countVenues = (array: any) => {
      let result = {};
      if (!array) return;
      array.forEach(function(item: any) {
        if (item.venue != null)
          result[item.venue] = (result[item.venue] || 0) + 1;
      });
      return result;
    };

    // Helper for setFilters
    const setFilterStyle = (state: Boolean = true, event: HTMLElement) => {
      if (!state) {
        event.classList.add('opacity-100', 'text-primary', 'font-bold', 'stroke-2');
        event.classList.remove('after:hidden');
        event.dataset.filter = 'active';
      } else {
        event.classList.remove('opacity-100', 'text-primary', 'font-bold', 'stroke-2');
        event.classList.add('after:hidden');
        event.dataset.filter = 'false';
      }
    };

    // Show events based on filter
    const setFilters = (name: String, event: any) => {
      const filterState = event.currentTarget.dataset.filter;
      let getAllResults = false;

      // Set the filter state when filter is already active
      if (filterState === 'active') {
        // Remove active style states
        setFilterStyle(true, event.currentTarget);
        getAllResults = true;

        // Remove filtered state on filter list parents
        event.currentTarget.closest('ul').classList.remove('filtered');
        weddingRef.value.querySelector('ul.filtered')?.classList?.remove('filtered');
      } else {
        // Set other filters
        weddingRef.value.querySelectorAll('[data-filter="active"]').forEach((button: HTMLElement) => {
          setFilterStyle(true, button);
        });
        // Add active style states
        event.currentTarget.closest('ul').classList.add('filtered');
        setFilterStyle(false, event.currentTarget);
      }

      // Filter results
      if (getAllResults) {
        results.value = events.value;
      } else {
        results.value = events.value.filter((event: any) => {
          const tags = [event.venue, event.seasons];
          return tags.includes(name) || tags.includes(name);
        });
      }

      // Toggle filter dropdown
      isShow.value = false;
      isVenue.value = false;
    }

    // Handle filters toggle on mobile
    const toggleFilters = (scope: string) => {
      if (scope === 'isShow') {
        isShow.value = !isShow.value;
        isVenue.value = false;
      } else {
        isVenue.value = !isVenue.value;
        isShow.value = false;
      }
    }

    // Set seasons icon
    // Use of slice due to Strapi returning enumaration fields value with commas
    const setSeasonIcon = (name: string) => {
      if (name.includes(',')) {
        name = name.slice(0, -1);
      }
      return name;
    }

    // Set cache
    onMounted(() => {
      addTags([{ prefix: CacheTagPrefix.View, value: 'weddings' }]);
    })

    return {
      countSeasons, countVenues, events, results, setFilters, weddingRef, toggleFilters, isShow, isVenue, setSeasonIcon, page, WeddingFlowerGallery, toggleGallery, viewWeddingFlowerGallery, galleryButtonText
    }
  },
  head() {
    return getMetaInfo(this.page);
  },
});
